import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { ThemeTypes } from "Types/enums";

export function useTheme() {

  const { theme, setTheme } = useContext(ThemeContext);

  const toggleTheme = () => {
    setTheme(theme === ThemeTypes.LIGHT ? ThemeTypes.DARK : ThemeTypes.LIGHT);
  }

  return { theme, toggleTheme }
  
}